module.exports = __webpack_public_path__ + "img/right_5.19b49056.jpg";